import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full font-montserrat relative" }
const _hoisted_2 = { class: "relative w-full mb-[50px]" }
const _hoisted_3 = { class: "px-[10px] py-[20px] md:p-[20px] flex flex-col items-center relative bg-gray-50 min-h-screen top-[60px]" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", { class: "text-black font-bold py-[20px] text-center" }, "Home / List of articles", -1)
const _hoisted_5 = { class: "bg-white w-[100%] md:w-[95%] relative p-[10px]" }
const _hoisted_6 = { class: "text-black flex relative text-sm font-bold bg-white border border-gray-400 p-[10px] w-full" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "p-[5px] flex items-center w-[25px]" }, [
  /*#__PURE__*/_createElementVNode("input", {
    type: "checkbox",
    name: "",
    id: ""
  })
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "p-[5px] flex items-center w-[25px]" }, null, -1)
const _hoisted_9 = { class: "p-[5px] flex items-center relative" }
const _hoisted_10 = {
  type: "submit",
  for: "search",
  class: "absolute left-[10px] text-black cursor-pointer top-[10px] text-xl"
}
const _hoisted_11 = { class: "w-full relative" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("thead", { class: "w-full relative" }, [
  /*#__PURE__*/_createElementVNode("tr", { class: "text-black flex relative text-sm font-bold bg-gray-50 border border-gray-400 p-[10px] w-full" }, [
    /*#__PURE__*/_createElementVNode("td", { class: "p-[5px] flex w-[25px]" }),
    /*#__PURE__*/_createElementVNode("td", { class: "p-[5px] flex w-[25px]" }, "ID"),
    /*#__PURE__*/_createElementVNode("td", { class: "p-[5px] md:w-[calc(100%/6)] w-[calc(100%/3)] flex" }, "Title"),
    /*#__PURE__*/_createElementVNode("td", { class: "p-[5px] md:w-[calc(100%/6)] w-[calc(100%/3)] flex" }, "Author"),
    /*#__PURE__*/_createElementVNode("td", { class: "p-[5px] md:w-[calc(100%/6)] w-[calc(100%/3)] hidden" }, "Content"),
    /*#__PURE__*/_createElementVNode("td", { class: "p-[5px] md:w-[calc(100%/6)] w-[calc(100%/3)] flex" }, "Image"),
    /*#__PURE__*/_createElementVNode("td", { class: "p-[5px] md:w-[calc(100%/6)] w-[calc(100%/3)] md:flex hidden" }, "Date"),
    /*#__PURE__*/_createElementVNode("td", { class: "p-[5px] md:w-[calc(100%/6)] w-[calc(100%/3)] md:flex hidden" }, "Source"),
    /*#__PURE__*/_createElementVNode("td", { class: "p-[5px] md:w-[calc(100%/6)] w-[calc(100%/3)] md:flex hidden" })
  ])
], -1)
const _hoisted_13 = { class: "w-full relative" }
const _hoisted_14 = { class: "flex justify-center items-center mt-8 space-x-4" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = {
  disabled: true,
  class: "bg-gray-200 text-gray-700 font-bold py-2 px-4 rounded cursor-pointer"
}
const _hoisted_17 = ["disabled"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "w-full border-t border-gray-400 py-[50px] flex justify-center items-center" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-center font-bold text-sm" }, "© 2023 Cotonou Cadjehoun, Tous droits réservés.")
], -1)

import headerComponent from '../components/headerComponentAdmin.vue'
import rowArticle from '../components/rowArticle.vue'
import { ref, onMounted } from 'vue';
import { search } from 'ionicons/icons';
import { searchOutline } from 'ionicons/icons';
import axios from 'axios';
import axiosInstance from '@/plugins/axios';

const pageSize = 6; 

export default /*#__PURE__*/_defineComponent({
  __name: 'ListeOfArticles',
  setup(__props) {

const pageTitle = ref('List of articles'); 
const articles = ref<any[]>([]);
const filteredArticles = ref<any[]>([]);


const allArticles = ref<any[]>([]); 

// ...

// ... (votre code existant)

const fetchAllArticles = async () => {
    try {
        let allArticles: any[] = [];
        let nextPage = '/articles/';

        while (nextPage) {
            const response = await axiosInstance.get(nextPage);

            if (response.status === 200 || response.status === 201 || response.status === 204) {
                const { results, next } = response.data;
                allArticles = allArticles.concat(results);
                nextPage = next;
            } else {
                nextPage = null;
            }
        }
        return allArticles;
    } catch (error) {
        console.error('Erreur lors du chargement des articles', error);
        return [];
    }
};

const handleSearch = async (event: any) => {
    const searchTerm = event.target.value.toLowerCase().trim();

    if (!searchTerm) {
        filteredArticles.value = articles.value;
    } else {
        const allArticles = await fetchAllArticles();

        if (allArticles.length > 0) {
            filteredArticles.value = allArticles.filter(article => {
                return (
                    (article.title && article.title.toLowerCase().includes(searchTerm)) ||
                    (article.content && article.content.toLowerCase().includes(searchTerm))
                );
            });
        }
    }
};




onMounted(async () => {
  document.title = pageTitle.value;
  await fetchArticles(); 
  try {
    const response = await axiosInstance.get('/articles/');
    if (response.status === 200 || response.status === 201 || response.status === 204) {
      const fetchedArticles = response.data.results;
      // Sort fetched articles by date if needed
      fetchedArticles.sort((a: any, b: any) => {
        return new Date(b.date).getTime() - new Date(a.date).getTime();
      });
      articles.value = fetchedArticles;
      filteredArticles.value = fetchedArticles;
    }
  } catch (error) {
    console.error('Erreur lors du chargement des articles', error);
  }

});

const currentPage = ref(1);
const hasPreviousPage = ref(false);
const hasNextPage = ref(false);

const loadArticles = async (page: number) => {
  try {
    const token = localStorage.getItem('token');
    if (!token) return;

    const response = await axiosInstance.get(`/articles/?page=${page}&page_size=${pageSize}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.status === 200 || response.status === 201 || response.status === 204) {
      const { results, previous, next } = response.data;
      filteredArticles.value = results;
      hasPreviousPage.value = !!previous;
      hasNextPage.value = !!next;
    }
  } catch (error) {
    console.error('Erreur lors du chargement des articles', error);
  }
};


const loadPreviousPage = () => {
  if (hasPreviousPage.value) {
    currentPage.value--;
    loadArticles(currentPage.value);
  }
};

const loadNextPage = () => {
  if (hasNextPage.value) {
    currentPage.value++;
    loadArticles(currentPage.value);
  }
};

onMounted(() => {
  loadArticles(currentPage.value);
});

const fetchArticles = async () => {
    try {
        const response = await axiosInstance.get('/articles/');
        if (response.status === 200 || response.status === 201 || response.status === 204) {
            const fetchedArticles = response.data.results;
            fetchedArticles.sort((a: any, b: any) => {
                return new Date(b.date).getTime() - new Date(a.date).getTime();
            });
            articles.value = fetchedArticles;
            filteredArticles.value = fetchedArticles;
        }
    } catch (error) {
        console.error('Erreur lors du chargement des articles', error);
    }
};

const totalPageCount = ref(0);

const fetchTotalPageCount = async () => {
  try {
    const response = await axiosInstance.get('/articles/');
    if (response.status === 200 || response.status === 201 || response.status === 204) {
      const totalArticles = response.data.count;
      totalPageCount.value = Math.ceil(totalArticles / pageSize);
    }
  } catch (error) {
    console.error('Erreur lors du chargement du nombre total de pages', error);
  }
};

onMounted(() => {
  fetchTotalPageCount();
})




return (_ctx: any,_cache: any) => {
  const _component_ion_icon = _resolveComponent("ion-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(headerComponent),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _hoisted_8,
            _createElementVNode("form", null, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("input", {
                  type: "search",
                  name: "search",
                  class: "border border-gray-700 pl-[30px] outline-none w-[250px] rounded-[5px] py-[5px] px-[10px]",
                  placeholder: "Search...",
                  id: "search",
                  onInput: _cache[0] || (_cache[0] = ($event: any) => (handleSearch($event)))
                }, null, 32),
                _createElementVNode("label", _hoisted_10, [
                  _createVNode(_component_ion_icon, { icon: _unref(searchOutline) }, null, 8, ["icon"])
                ])
              ])
            ])
          ]),
          _createElementVNode("table", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("tbody", _hoisted_13, [
              _createVNode(rowArticle, { articles: filteredArticles.value }, null, 8, ["articles"])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("button", {
              onClick: loadPreviousPage,
              disabled: !hasPreviousPage.value,
              class: _normalizeClass({ 'bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded': hasPreviousPage.value, 'bg-gray-300 text-gray-500 cursor-not-allowed py-2 px-4 rounded': !hasPreviousPage.value })
            }, " Previous ", 10, _hoisted_15),
            _createElementVNode("button", _hoisted_16, _toDisplayString(currentPage.value) + " / " + _toDisplayString(totalPageCount.value), 1),
            _createElementVNode("button", {
              onClick: loadNextPage,
              disabled: !hasNextPage.value,
              class: _normalizeClass({ 'bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded': hasNextPage.value, 'bg-gray-300 text-gray-500 cursor-not-allowed py-2 px-4 rounded': !hasNextPage.value })
            }, " Next ", 10, _hoisted_17)
          ])
        ])
      ])
    ]),
    _hoisted_18
  ]))
}
}

})